module.exports = __webpack_public_path__ + "img/logo.aeada1b2.svg";